import React from "react";

export default function SessionExpiredModal({ show, seconds }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999]">
      <div className="bg-white p-8 rounded-xl shadow-xl max-w-sm text-center">
        <h2 className="text-2xl font-bold text-red-600 mb-4">
          Sessão Expirada
        </h2>

        <p className="text-gray-700 mb-4">
          Sua sessão expirou. Você será redirecionado para o login em:
        </p>

        <div className="text-4xl font-bold text-indigo-600 mb-4">
          {seconds}s
        </div>

        <p className="text-gray-500 text-sm">
          Faça login novamente para continuar.
        </p>
      </div>
    </div>
  );
}
